import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const ListTicketsDocument = gql`
    query ListTickets {
  ticketList {
    createdAt
    updatedAt
    closedAt
    closedAt
    name
    subject
    description
    status
    category
    sub_category
    username
    phone
    email
    contactTime
  }
}
    `;

/**
 * __useListTicketsQuery__
 *
 * To run a query within a React component, call `useListTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTicketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTicketsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ListTicketsQuery, Types.ListTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListTicketsQuery, Types.ListTicketsQueryVariables>(ListTicketsDocument, options);
      }
export function useListTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListTicketsQuery, Types.ListTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListTicketsQuery, Types.ListTicketsQueryVariables>(ListTicketsDocument, options);
        }
export type ListTicketsQueryHookResult = ReturnType<typeof useListTicketsQuery>;
export type ListTicketsLazyQueryHookResult = ReturnType<typeof useListTicketsLazyQuery>;
export type ListTicketsQueryResult = Apollo.QueryResult<Types.ListTicketsQuery, Types.ListTicketsQueryVariables>;
export const GetTicketDocument = gql`
    query getTicket($ticket: String!) {
  getTicket(ticketName: $ticket) {
    createdAt
    updatedAt
    closedAt
    name
    subject
    description
    category
    sub_category
    status
    username
    phone
    email
    attachmentsUrl {
      url
      fileName
    }
    contactTime
  }
}
    `;

/**
 * __useGetTicketQuery__
 *
 * To run a query within a React component, call `useGetTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketQuery({
 *   variables: {
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useGetTicketQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTicketQuery, Types.GetTicketQueryVariables>(GetTicketDocument, options);
      }
export function useGetTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTicketQuery, Types.GetTicketQueryVariables>(GetTicketDocument, options);
        }
export type GetTicketQueryHookResult = ReturnType<typeof useGetTicketQuery>;
export type GetTicketLazyQueryHookResult = ReturnType<typeof useGetTicketLazyQuery>;
export type GetTicketQueryResult = Apollo.QueryResult<Types.GetTicketQuery, Types.GetTicketQueryVariables>;
export const ListCommentsDocument = gql`
    query listComments($ticket: String!) {
  commentList(ticketName: $ticket) {
    createdAt
    updatedAt
    comment
    username
    email
    attachmentsUrl {
      url
      fileName
    }
    ticket {
      createdAt
      updatedAt
      closedAt
      name
      subject
      description
      status
      category
      sub_category
      username
      phone
      email
      attachmentsUrl {
        url
        fileName
      }
    }
  }
}
    `;

/**
 * __useListCommentsQuery__
 *
 * To run a query within a React component, call `useListCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCommentsQuery({
 *   variables: {
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useListCommentsQuery(baseOptions: Apollo.QueryHookOptions<Types.ListCommentsQuery, Types.ListCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListCommentsQuery, Types.ListCommentsQueryVariables>(ListCommentsDocument, options);
      }
export function useListCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListCommentsQuery, Types.ListCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListCommentsQuery, Types.ListCommentsQueryVariables>(ListCommentsDocument, options);
        }
export type ListCommentsQueryHookResult = ReturnType<typeof useListCommentsQuery>;
export type ListCommentsLazyQueryHookResult = ReturnType<typeof useListCommentsLazyQuery>;
export type ListCommentsQueryResult = Apollo.QueryResult<Types.ListCommentsQuery, Types.ListCommentsQueryVariables>;
export const CategoryListDocument = gql`
    query categoryList {
  categoryList {
    name
    arabicName
    subcategories {
      name
      arabicName
    }
  }
}
    `;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<Types.CategoryListQuery, Types.CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CategoryListQuery, Types.CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CategoryListQuery, Types.CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CategoryListQuery, Types.CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<Types.CategoryListQuery, Types.CategoryListQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  userList {
    name
    email
    mobile
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<Types.GetUsersQuery, Types.GetUsersQueryVariables>;
export const GetBranchesDocument = gql`
    query getBranches {
  branchList {
    id
    name
  }
}
    `;

/**
 * __useGetBranchesQuery__
 *
 * To run a query within a React component, call `useGetBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBranchesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetBranchesQuery, Types.GetBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBranchesQuery, Types.GetBranchesQueryVariables>(GetBranchesDocument, options);
      }
export function useGetBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBranchesQuery, Types.GetBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBranchesQuery, Types.GetBranchesQueryVariables>(GetBranchesDocument, options);
        }
export type GetBranchesQueryHookResult = ReturnType<typeof useGetBranchesQuery>;
export type GetBranchesLazyQueryHookResult = ReturnType<typeof useGetBranchesLazyQuery>;
export type GetBranchesQueryResult = Apollo.QueryResult<Types.GetBranchesQuery, Types.GetBranchesQueryVariables>;
export const MenuItemListDocument = gql`
    query menuItemList {
  menuItemList {
    id
    name
    children {
      id
      name
      sequence
      web_icon_data
      xmlid
    }
  }
}
    `;

/**
 * __useMenuItemListQuery__
 *
 * To run a query within a React component, call `useMenuItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuItemListQuery({
 *   variables: {
 *   },
 * });
 */
export function useMenuItemListQuery(baseOptions?: Apollo.QueryHookOptions<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>(MenuItemListDocument, options);
      }
export function useMenuItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>(MenuItemListDocument, options);
        }
export type MenuItemListQueryHookResult = ReturnType<typeof useMenuItemListQuery>;
export type MenuItemListLazyQueryHookResult = ReturnType<typeof useMenuItemListLazyQuery>;
export type MenuItemListQueryResult = Apollo.QueryResult<Types.MenuItemListQuery, Types.MenuItemListQueryVariables>;
export const CreateTicketDocument = gql`
    mutation createTicket($subject: String!, $description: String!, $category: String!, $sub_category: String!, $username: String!, $email: String!, $phone: String!, $branch: String!, $attachments: [AttachmentInput!], $contactTime: [String!]) {
  createTicket(
    subject: $subject
    description: $description
    category: $category
    sub_category: $sub_category
    username: $username
    email: $email
    phone: $phone
    branch: $branch
    attachments: $attachments
    contactTime: $contactTime
  ) {
    name
  }
}
    `;
export type CreateTicketMutationFn = Apollo.MutationFunction<Types.CreateTicketMutation, Types.CreateTicketMutationVariables>;

/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketMutation, { data, loading, error }] = useCreateTicketMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      description: // value for 'description'
 *      category: // value for 'category'
 *      sub_category: // value for 'sub_category'
 *      username: // value for 'username'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      branch: // value for 'branch'
 *      attachments: // value for 'attachments'
 *      contactTime: // value for 'contactTime'
 *   },
 * });
 */
export function useCreateTicketMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTicketMutation, Types.CreateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTicketMutation, Types.CreateTicketMutationVariables>(CreateTicketDocument, options);
      }
export type CreateTicketMutationHookResult = ReturnType<typeof useCreateTicketMutation>;
export type CreateTicketMutationResult = Apollo.MutationResult<Types.CreateTicketMutation>;
export type CreateTicketMutationOptions = Apollo.BaseMutationOptions<Types.CreateTicketMutation, Types.CreateTicketMutationVariables>;
export const CreateCommentDocument = gql`
    mutation createComment($ticket_name: String!, $comment: String!, $attachments: [AttachmentInput!]) {
  createComment(
    ticket_name: $ticket_name
    comment: $comment
    attachments: $attachments
  ) {
    _id
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      ticket_name: // value for 'ticket_name'
 *      comment: // value for 'comment'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<Types.CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>;
export const CommentAddedDocument = gql`
    subscription commentAdded($ticket_name: String!) {
  commentAdded(ticket_name: $ticket_name) {
    comment
  }
}
    `;

/**
 * __useCommentAddedSubscription__
 *
 * To run a query within a React component, call `useCommentAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentAddedSubscription({
 *   variables: {
 *      ticket_name: // value for 'ticket_name'
 *   },
 * });
 */
export function useCommentAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.CommentAddedSubscription, Types.CommentAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.CommentAddedSubscription, Types.CommentAddedSubscriptionVariables>(CommentAddedDocument, options);
      }
export type CommentAddedSubscriptionHookResult = ReturnType<typeof useCommentAddedSubscription>;
export type CommentAddedSubscriptionResult = Apollo.SubscriptionResult<Types.CommentAddedSubscription>;
export const GetVideosDocument = gql`
    query getVideos {
  getVideos {
    EnglishName
    url
    EnglishDescription
    ArabicName
    ArabicDescription
    module
  }
}
    `;

/**
 * __useGetVideosQuery__
 *
 * To run a query within a React component, call `useGetVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVideosQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetVideosQuery, Types.GetVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetVideosQuery, Types.GetVideosQueryVariables>(GetVideosDocument, options);
      }
export function useGetVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetVideosQuery, Types.GetVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetVideosQuery, Types.GetVideosQueryVariables>(GetVideosDocument, options);
        }
export type GetVideosQueryHookResult = ReturnType<typeof useGetVideosQuery>;
export type GetVideosLazyQueryHookResult = ReturnType<typeof useGetVideosLazyQuery>;
export type GetVideosQueryResult = Apollo.QueryResult<Types.GetVideosQuery, Types.GetVideosQueryVariables>;